import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
export function Progress() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          clearInterval(interval);
          setTimeout(() => navigate('/upload/success'), 500);
          return 100;
        }
        return p + 2;
      });
    }, 50);
    return () => clearInterval(interval);
  }, [navigate]);
  return <div className="w-full h-full bg-black flex flex-col items-center justify-center relative" data-id="element-721">
      <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-722">
        {/* Background Ring */}
        <svg className="absolute inset-0 w-full h-full transform -rotate-90" data-id="element-723">
          <circle cx="96" cy="96" r="88" stroke="currentColor" strokeWidth="8" fill="transparent" className="text-surface" data-id="element-724" />
          {/* Progress Ring */}
          <motion.circle cx="96" cy="96" r="88" stroke="currentColor" strokeWidth="8" fill="transparent" strokeDasharray={2 * Math.PI * 88} strokeDashoffset={2 * Math.PI * 88 * (1 - progress / 100)} className="text-primary" strokeLinecap="round" data-id="element-725" />
        </svg>

        <div className="text-center" data-id="element-726">
          <span className="text-4xl font-poppins font-bold text-white" data-id="element-727">
            {progress}%
          </span>
        </div>
      </div>

      <h2 className="text-white font-poppins font-bold text-xl mt-8 mb-2" data-id="element-728">
        {progress < 50 ? 'Compressing video...' : 'Uploading to Laugh Haus...'}
      </h2>
      <p className="text-softGray text-sm" data-id="element-729">Please don't close the app</p>

      <button onClick={() => navigate('/feed')} className="absolute bottom-12 text-softGray font-medium hover:text-white transition-colors" data-id="element-730">
        Cancel Upload
      </button>
    </div>;
}